import { render, staticRenderFns } from "./CarriersSelect.vue?vue&type=template&id=10cfa8f1&scoped=true"
import script from "./CarriersSelect.vue?vue&type=script&lang=js"
export * from "./CarriersSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cfa8f1",
  null
  
)

export default component.exports